export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
const mockDataEnv = process.env.REACT_APP_USE_MOCK_DATA;
export const USE_MOCK_DATA = typeof mockDataEnv === 'string'
  ? mockDataEnv.toLowerCase() === 'true'
  : true;
export const IS_DEVELOPMENT = process.env.REACT_APP_ENV === 'development';

export const API_ENDPOINTS = {
  // 1. Auth & Account (V2 Token & Header based)
  LOGIN: '/api/v2/auth/login',
  LOGOUT: '/api/v2/auth/logout',
  ME: '/api/v2/auth/me', 


  // 2. Organizations (Companies)
  COMPANIES: '/api/v1/companies/',
  COMPANY_DETAILS: (id) => `/api/v1/companies/${id}`,

  // 3. Sites
  SITES: '/api/v1/sites/',
  SITE_DETAILS: (id) => `/api/v1/sites/${id}`,
  SITE_STATS: (id) => `/api/v1/sites/${id}/stats`,
  SITES_EXPORT_CSV: '/api/v1/sites/export/csv',
  
  // 4. Users Management (Unified Table for Admin, TL, Engineer, Customer)
  USERS: '/api/v1/users/', 
  USER_DETAILS: (id) => `/api/v1/users/${id}`,
  USERS_BY_ROLE: (role) => `/api/v1/users/?role=${role}`, // e.g., ?role=ENGINEER
  
  // Engineer Specific Operations
  ENGINEER_UPDATE_TL: (id) => `/api/v1/users/${id}/team-lead`,
  ENGINEER_DASHBOARD: (id) => `/api/v1/users/${id}/engineer-dashboard`,
  ENGINEER_SCHEDULE: (id) => `/api/v1/users/${id}/schedule`,
  
  // Customer Specific Operations
  CUSTOMER_SITES: (id) => `/api/v1/users/${id}/sites`,
  CUSTOMER_DASHBOARD: (customerId, siteId) => `/api/v1/users/${customerId}/dashboard/${siteId}`,
  CUSTOMER_ESCALATION_MATRIX: (customerId, siteId) => `/api/v1/users/${customerId}/escalation-matrix/${siteId}`,
  CUSTOMER_ESCALATION_MATRIX_DOWNLOAD: (customerId, siteId) => `/api/v1/users/${customerId}/escalation-matrix/${siteId}/download`,
  CUSTOMER_TICKET_STATS: (id) => `/api/v1/users/${id}/ticket-stats`,
  CUSTOMER_ACTIVE_CONTRACT: (id) => `/api/v1/users/${id}/active-contract`, // Or derived from sites

  // Team Lead Specific Operations
  TL_PERFORMANCE: (id) => `/api/v1/users/${id}/tl-performance`,

  // 5. Contracts
  CONTRACTS: '/api/v1/contracts/',
  CONTRACT_DETAILS: (id) => `/api/v1/contracts/${id}`,
  CONTRACTS_BY_SITE: (siteId) => `/api/v1/contracts/?site_id=${siteId}`,
  CONTRACT_TOGGLE_STATUS: (id) => `/api/v1/contracts/${id}/status`,
  CONTRACT_RENEW: (id) => `/api/v1/contracts/renew/${id}`,
  CONTRACTS_EXPORT_CSV: '/api/v1/contracts/export/csv',

  // 6. Tickets
  TICKETS: '/api/v1/tickets/',
  TICKET_DETAILS: (id) => `/api/v1/tickets/${id}`,
  TICKET_CLOSE: (id) => `/api/v1/work-reports/finalize-pdf/${id}`,
  TICKET_REOPEN: (id) => `/api/v1/tickets/${id}/reopen`,
  TICKET_ASSIGN: (id) => `/api/v1/tickets/${id}/assign`,
  TICKETS_BY_STATUS: (status) => `/api/v1/tickets/?status=${status}`,
  TICKET_START_WORK: (id) => `/api/v1/tickets/${id}/start-work`,
  TICKETS_EXPORT_CSV: '/api/v1/tickets/export/csv',
  
  // Ticket Sub-resources
  TICKET_REPORT_PDF: (id) => `/api/v1/tickets/${id}/report/pdf`,
  TICKET_COMMENTS: (id) => `/api/v1/tickets/${id}/comments`,

  // 7. Work Reports (Engineer Submissions)
  WORK_REPORTS: '/api/v1/work-reports/',
  WORK_REPORT_DETAILS: (id) => `/api/v1/work-reports/${id}`,
  WORK_REPORT_SUBMIT: (id) => `/api/v1/work-reports/${id}/submit`,
  
  // 8. Knowledge Base & Utilities
  KNOWLEDGE_BASE_CATEGORIES: '/api/v1/knowledge-base/categories',
  KNOWLEDGE_BASE_ARTICLES: '/api/v1/knowledge-base/articles',
  KNOWLEDGE_BASE_ARTICLE: (id) => `/api/v1/knowledge-base/articles/${id}`,
  KNOWLEDGE_BASE_SEARCH: '/api/v1/knowledge-base/search',
  EMERGENCY_CONTACTS: '/api/v1/emergency-contacts',
  
  // Status
  STATUS: '/status',
  STATUS_DB: '/status/db',

  // 9. Escalation Matrix
  ESCALATION_MATRICES: '/api/v1/escalation-matrices/',
  ESCALATION_MATRIX_DETAILS: (id) => `/api/v1/escalation-matrices/${id}`,

  // 10. Logs
  LOGS: '/api/v1/logs',

  // 11. System Types and Problems
  SYSTEM_TYPES: '/api/v1/system-types/',
  SYSTEM_TYPES_PROBLEM_MAPPING: '/api/v1/system-types/problem-mapping',
  SYSTEM_TYPE_DETAIL: (id) => `/api/v1/system-types/${id}`,
  SYSTEM_TYPE_PROBLEMS: (id) => `/api/v1/system-types/${id}/problems`,
  SYSTEM_TYPE_PROBLEM_DETAIL: (id, problemId) => `/api/v1/system-types/${id}/problems/${problemId}`,
  SYSTEM_TYPES_RESTORE_DEFAULTS: '/api/v1/system-types/restore-defaults',

  // 12.Branch Address
  BRANCH_ADDRESSES: '/api/v1/branch-addresses/',
  BRANCH_ADDRESS_DETAILS: (id) => `/api/v1/branch-addresses/${id}`,
  BRANCH_ADDRESS_SET_DEFAULT: (id) => `/api/v1/branch-addresses/${id}/set-default`,
};

export const TOKEN_KEY = 'amc_access_token';
export const USER_KEY = 'amc_user_data';
export const REQUEST_TIMEOUT = 30000;